import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  students: [],
  classrooms: [],
  subjects: [],
  incompleteClassResultCount: 0,
  incompleteStudentResultCount: 0,
  loading: false,
  error: null,
};

const teacherDataSlice = createSlice({
  name: 'teacherData',
  initialState,
  reducers: {
    setTeacherData: (state, action) => {
      const data = action.payload;
      state.students = data.students || [];
      state.classrooms = data.classrooms || [];
      state.subjects = data.subjects || [];
      state.incompleteClassResultCount = data.incompleteClassResultCount || 0;
      state.incompleteStudentResultCount = data.incompleteStudentResultCount || 0;
      state.loading = false;
      state.error = null;
    },
    setStudents: (state, action) => {
      state.students = action.payload;
    },
    setClassrooms: (state, action) => {
      state.classrooms = action.payload;
    },
    setSubjects: (state, action) => {
      state.subjects = action.payload;
    },
    updateStudent: (state, action) => {
      const { id, updates } = action.payload;
      const studentIndex = state.students.findIndex(student => student.id === id);
      if (studentIndex !== -1) {
        state.students[studentIndex] = { ...state.students[studentIndex], ...updates };
      }
    },
    clearTeacherData: (state) => {
      state.students = [];
      state.classrooms = [];
      state.subjects = [];
      state.incompleteClassResultCount = 0;
      state.incompleteStudentResultCount = 0;
      state.loading = false;
      state.error = null;
    },
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
    setError: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
  },
});

export const {
  setTeacherData,
  setStudents,
  setClassrooms,
  setSubjects,
  updateStudent,
  clearTeacherData,
  setLoading,
  setError,
} = teacherDataSlice.actions;

export default teacherDataSlice.reducer;
